export type CountryCode = {
  code: string;
  flag: string;
  pattern: string;
  example: string;
};

export const countryCodes: Record<string, CountryCode> = {
  FR: {
    code: "+33",
    flag: "🇫🇷",
    pattern: "[0-9]{9}",
    example: "6 12 34 56 78",
  },
  PT: {
    code: "+351",
    flag: "🇵🇹",
    pattern: "[0-9]{9}",
    example: "912 345 678",
  },
  GB: {
    code: "+44",
    flag: "🇬🇧",
    pattern: "[0-9]{10}",
    example: "7911 123456",
  },
  ES: {
    code: "+34",
    flag: "🇪🇸",
    pattern: "[0-9]{9}",
    example: "612 345 678",
  },
  DE: {
    code: "+49",
    flag: "🇩🇪",
    pattern: "[0-9]{10,11}",
    example: "1512 3456789",
  },
  IT: {
    code: "+39",
    flag: "🇮🇹",
    pattern: "[0-9]{10}",
    example: "312 345 6789",
  },
  BE: {
    code: "+32",
    flag: "🇧🇪",
    pattern: "[0-9]{9}",
    example: "470 12 34 56",
  },
  CH: {
    code: "+41",
    flag: "🇨🇭",
    pattern: "[0-9]{9}",
    example: "76 123 45 67",
  },
  LU: {
    code: "+352",
    flag: "🇱🇺",
    pattern: "[0-9]{9}",
    example: "621 123 456",
  },
  MA: {
    code: "+212",
    flag: "🇲🇦",
    pattern: "[0-9]{9}",
    example: "612 34 56 78",
  },
  DZ: {
    code: "+213",
    flag: "🇩🇿",
    pattern: "[0-9]{9}",
    example: "551 23 45 67",
  },
  TN: {
    code: "+216",
    flag: "🇹🇳",
    pattern: "[0-9]{8}",
    example: "21 234 567",
  },
  CA: {
    code: "+1",
    flag: "🇨🇦",
    pattern: "[0-9]{10}",
    example: "514 123 4567",
  },
  US: {
    code: "+1",
    flag: "🇺🇸",
    pattern: "[0-9]{10}",
    example: "202 555 0123",
  },
  AE: {
    code: "+971",
    flag: "🇦🇪",
    pattern: "[0-9]{9}",
    example: "50 123 4567",
  },
  SA: {
    code: "+966",
    flag: "🇸🇦",
    pattern: "[0-9]{9}",
    example: "50 123 4567",
  },
  SN: {
    code: "+221",
    flag: "🇸🇳",
    pattern: "[0-9]{9}",
    example: "70 123 45 67",
  },
};
